import PropTypes from 'prop-types';
import React from 'react';
import Button from '../../../../Input/Button/Button';
import InputField from '../../../../Input/InputField/InputField';
import { CREATE_LAYOUT } from '../../LoginLayoutComponent';
import './EmailLoginForm.scss';

export default class EmailLoginForm extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        /**
         * submit button onClick function
         */
        onClick: PropTypes.func.isRequired,
        /**
         * function to handle email input
         */
        handleEmailInput: PropTypes.func.isRequired,
        /**
         * function to handle password input
         */
        handlePasswordInput: PropTypes.func.isRequired,
        /**
         * function to handle usernameInput
         */
        handleUsernameInput: PropTypes.func,
        /**
         * email value
         */
        email: PropTypes.string,
        /**
         * password value
         */
        password: PropTypes.string,
        /**
         * username value
         */
        username: PropTypes.string,
        /**
         * email error
         */
        emailError: PropTypes.string,
        /**
         * password error
         */
        passwordError: PropTypes.string,
        /**
         * general error
         */
        generalError: PropTypes.string,
        /**
         * username error
         */
        usernameError: PropTypes.string,
        /**
         * state passed down on whether the call has finished processing
         */
        loaded: PropTypes.bool,
        /**
         * location of form
         */
        location: PropTypes.oneOf(['create', 'login']),
        /**
         * whether to use the username form
         */
        showUsernameField: PropTypes.bool,
    };

    static defaultProps = {
        showUsernameField: false,
        featureFlags: {},
    };

    onKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.props.onClick();
        }
    };

    render() {
        let buttonDisabled = !this.props.loaded;
        if (this.props.showUsernameField) {
            const nameFieldIsValid = this.props.name && this.props.name.length;
            buttonDisabled = !(
                this.props.email &&
                this.props.email.length &&
                this.props.password &&
                this.props.password.length &&
                this.props.loaded &&
                nameFieldIsValid
            );
        } else if (
            !(
                this.props.email &&
                this.props.email.length &&
                this.props.password &&
                this.props.password.length &&
                this.props.loaded
            )
        ) {
            buttonDisabled = true;
        }
        const buttonText = !this.props.loaded ? 'Processing' : 'Submit';
        const showNameField = this.props.location === CREATE_LAYOUT;
        return (
            <div className="component-Login-LoginLayoutComponent-Layouts-EmailLoginForm">
                <div className="input-section email-login-input-section email-field">
                    <div className="form-label">
                        Email{' '}
                        <span className="errorMessage ml-1">
                            {this.props.emailError}
                        </span>
                    </div>
                    <InputField
                        name={'email-input-reset-password'}
                        qaDataAttr={'email'}
                        onChange={this.props.handleEmailInput}
                        value={this.props.email}
                    />
                </div>
                {showNameField && (
                    <div className="input-section username-login-input-section username-field">
                        <div className="form-label">
                            Your name{' '}
                            <span className="errorMessage ml-1">
                                {this.props.nameError}
                            </span>
                        </div>
                        <InputField
                            type="text"
                            name={'username-input-reset-password'}
                            qaDataAttr={'name'}
                            onChange={this.props.handleNameInput}
                            value={this.props.name}
                        />
                    </div>
                )}
                <div className="input-section passowrd-login-input-section password-field">
                    <div className="form-label">
                        Password{' '}
                        <span className="errorMessage ">
                            {this.props.passwordError}
                        </span>
                    </div>
                    <InputField
                        type="password"
                        name={'email-input-reset-password'}
                        qaDataAttr={'password'}
                        onKeyPress={this.onKeyPress}
                        onChange={this.props.handlePasswordInput}
                        value={this.props.password}
                    />
                </div>
                <div className="errorMessage">{this.props.generalError}</div>
                {!this.props.emailError &&
                !this.props.passwordError &&
                !this.props.generalError ? (
                    <div>
                        <Button
                            type={'solid'}
                            qaAttr={buttonText}
                            value={buttonText}
                            disabled={buttonDisabled}
                            onClick={this.props.onClick}
                        />
                    </div>
                ) : null}
            </div>
        );
    }
}
